import FilterDate from '@/Enums/FilterDate.enum';
import DateFormat from '@/Enums/Format/DateFormat.enum';
import type { OfflineSalesFilters, WebVisitsFilters } from '@/types/Attribution/filters.types';
import moment from 'moment';
import { getDefaultDateRangeFormatted } from '../date/dateRange.helpers';

export const getDefaultWebVisitsFilter = (): WebVisitsFilters => ({
  ...getDefaultDateRangeFormatted(7),
  dateRangeFormat: FilterDate.LAST_7_DAYS,
  whitelabels: [],
  clients: [],
  advertisers: [],
  campaigns: [],
  placement: [],
  events: [],
});

export const getDefaultOfflineSalesFilter = (): OfflineSalesFilters => ({
  dateRangeStart: moment().startOf('month').format(DateFormat.Iso8601),
  dateRangeEnd: moment().endOf('month').format(DateFormat.Iso8601),
  advertiserId: null,
});
